import { ElementTypes } from '../types/element';
import { ISpace } from '../types/space';
import { GetTableData_getTableData_columns } from '../../graphql/core/types/GetTableData';
import { ColumnType } from '../modules/core/graphql/types';
import { checkIfLookupIsLookingAtRecordReference } from '../modules/core/helpers';

export const isAbsentField = (space: ISpace<ElementTypes>, field: any) =>
  !space ||
  !(
    space.type === ElementTypes.StaticAttachment ||
    space.type === ElementTypes.StaticText ||
    field
  );

export const getForeignTableIdByType = (field: GetTableData_getTableData_columns) => {
  let tableId = null;

  if (field.type === ColumnType.RECORD_REFERENCE || field.type === ColumnType.SUBTABLE) {
    tableId = field.typeOptions.foreignTableId;
  } else if (field.type === ColumnType.LOOKUP && checkIfLookupIsLookingAtRecordReference(field)) {
    tableId = field.typeOptions.lookupTypeOptions.foreignTableId;
  }

  return tableId;
};